import React, { useEffect, useState } from "react";
import { setSimulateurObject } from "../../../actions/simulateur.action";
import { useDispatch } from "react-redux";
import { styles } from "../../../stylesheets/simulateurs.css";
import "../../../stylesheets/simulateursBis.css";
import ButtonYesno from "../../../components/buttons/button.yesno.js";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import SelectDepartement from "../../../components/selects/select.departement";
import Simulateur_A1_12VEFA from "../simulateur.A1.12VEFA/simulateur.A1.12VEFA";
import SelectCommon from "../../../components/selects/select.common";
import { ToolTipPerso } from "../../../components/selects/tooltip_perso";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import ConventionHonoraires from "../../../components/questions/ConventionHonoraires.js";
import CautionSansGarantieHypo from "../../../components/questions/CautionSansGarantieHypo.js";

// VEFA de 100 à 249 lots et ventes de locaux d'habitation dans le neuf
// simulateur id 15

function Simulateur_A2_5(props) {
  const dispatch = useDispatch();

  let currUser = JSON.parse(localStorage.getItem("user"));
  let currUserDep = 0;
  if (currUser.societe_zip.startsWith("97")) {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 3);
    currUserDep = parseInt(trimedZip);
  } else {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 2);
    currUserDep = parseInt(trimedZip);
  }

  const [departement, setDepartement] = useState(0);
  const [acteEnMain, setActeEnMain] = useState(0);
  const [pretHypo, setPretHypo] = useState(0);
  const [montant_exigible, setMontantExigible] = useState(0);
  const [tva_concerne, setTva] = useState("0.2");
  const [simu85, setSimu85] = useState(null);
  const currentIdSimu = 15;
  const [cautionSansGarantieHypo, setCautionSansGarantieHypo] = useState(0);
  const [simu114, setSimu114] = useState(null);
  const [montantVente, setMontantVente] = useState(0);
  const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
  const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);
  const [dependances, setDependancesState] = useState([]);

  const handleChange = async (setter, value) => {
    if (setter === setDepartement) {
      setDepartement(parseInt(value));
    } else setter(value);
    setInRedux(setter, value);
  };

  useEffect(() => {
    if (simu85 !== undefined && simu85 !== null) setDependances(simu85);
  }, [simu85]);

  useEffect(() => {
    if (simu114 !== undefined && simu114 !== null) setDependances(simu114);
  }, [simu114]);

  function setDependances(simu) {
    setInRedux("dependance", simu);
  }

  const handleChangeRemarque = async (value) => {
    localStorage.setItem("remarque", value);
  };

  function setInRedux(setter, value) {
    let object = {
      simulateurid: currentIdSimu,
      departementid: parseInt(departement),
      inputs: {
        montant_vente: parseInt(montantVente),
        montant_deb_add: parseInt(montantDeboursAdditionnels),
        debours_additionnels: parseInt(deboursAdditionnels),
        acte_en_main: parseInt(acteEnMain),
        montant_exigible: parseInt(montant_exigible),
        tva_concerne: parseFloat(tva_concerne),
        convention_honoraires : parseInt(props.conventionHonoraires),
      },
      pdfInputs: {
        nombre_convention_honoraires : parseInt(props.nombreConventionHonoraires),
        object_convention_honoraires : props.objectConventionHonoraires,
        montant_convention_honoraires : parseInt(props.montantConventionHonoraires),
        nom_signataire_convention_honoraires : props.nomSignataireConventionHonoraires,
        adresse_signataire_convention_honoraires : props.adresseSignataireConventionHonoraires,
      },
      dependances: dependances,
    };

    if (setter === setPretHypo) {
      if (value === 0) {
        setSimu85(null);
        setDependancesState([]);
        object.dependances = [];
      } else {
        object.dependances = dependances;
      }
    }

    if (setter === setCautionSansGarantieHypo && value === 1) {
      setPretHypo(0);
      setSimu85(null);
      setDependancesState([]);
      object.dependances = [];
    }

    if (setter === setCautionSansGarantieHypo && value === 0) {
      setSimu114(null);
      setDependancesState([]);
      object.dependances = [];
    }

    if (setter === "dependance") {
      if (dependances.length > 0) object.dependances = dependances;

      if (value !== undefined) {
        let validator = false;

        for (let i = 0; i < object["dependances"].length; i++) {
          if (object["dependances"][i]?.simulateurid === value.simulateurid) {
            object.dependances[i] = value;
            validator = true;
          }
        }

        if (validator === false) {
          object.dependances.push(value);
        }

        setDependancesState(object.dependances);
      }
    }

    if (setter === setMontantVente) {
      Object.assign(object["inputs"], { montant_vente: parseInt(value) });
    }

    if (setter === setMontantDeboursAdditionnels) {
      Object.assign(object["inputs"], { montant_deb_add: parseInt(value) });
    }

    if (setter === setDepartement) {
      object.departementid = parseInt(value);
    }

    if (setter === setDeboursAdditionnels) {
      Object.assign(object["inputs"], { debours_additionnels: parseInt(value) });
    }

    if (setter === setActeEnMain) {
      Object.assign(object["inputs"], { acte_en_main: parseInt(value) });
    }

    if (setter === setMontantExigible) {
      Object.assign(object["inputs"], { montant_exigible: parseInt(value) });
    }

    if (setter === setTva) {
      Object.assign(object["inputs"], { tva_concerne: parseFloat(value) });
    }

    if (setter === props.setConventionHonoraires) {
      if(value === 0){
        props.setNombreConventionHonoraires(1);
        props.setObjectConventionHonoraires(null);
        props.setMontantConventionHonoraires(null);
        props.setNomSignataireConventionHonoraires(null);
        props.setAdresseSignataireConventionHonoraires(null);
        Object.assign(
          object["inputs"], { convention_honoraires : parseInt(value) },
          object["pdfInputs"], {
            nombre_convention_honoraires : null,
            object_convention_honoraires : null,
            montant_convention_honoraires : null,
            nom_signataire_convention_honoraires : null,
            adresse_signataire_convention_honoraires : null
          },
        );
      } else {
        Object.assign(object["inputs"], { convention_honoraires : parseInt(value) });
      }
    }

    if (setter === props.setNombreConventionHonoraires) {
      Object.assign(object["pdfInputs"], { nombre_convention_honoraires : parseInt(value) });
    }

    if (setter === props.setObjectConventionHonoraires) {
      Object.assign(object["pdfInputs"], { object_convention_honoraires : value });
    }

    if (setter === props.setMontantConventionHonoraires) {
      Object.assign(object["pdfInputs"], { montant_convention_honoraires : parseInt(value)});
    }

    if (setter === props.setNomSignataireConventionHonoraires) {
      Object.assign(object["pdfInputs"], { nom_signataire_convention_honoraires : value });
    }

    if (setter === props.setAdresseSignataireConventionHonoraires) {
      Object.assign(object["pdfInputs"], { adresse_signataire_convention_honoraires : value });
    }

    if (props.isParent) {
      dispatch(setSimulateurObject(object));
    } else {
    }
  }

  const tvaVefa = [
    {
      id: 0.2,
      name: "20%",
    },
    {
      id: 0.1,
      name: "10%",
    },
    {
      id: 0.085,
      name: "8,5% (DOM)",
    },
    {
      id: 0.055,
      name: "5,5%",
    },
    {
      id: 0.021,
      name: "2,1% (DOM)",
    },
    {
      id: 0,
      name: "0% (DOM)",
    },
  ];

  return (
    <div style={styles.container}>
      <div className="cardSimulateur">
        <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id} />

        <TextfieldRemarques handleChange={handleChangeRemarque} />

        <p style={styles.cardSubTitle}>
          Pour la vente, acte tarifé au titre du Tableau 5, n° 55 (Art A444-92). Prêt aux particuliers associé acte
          tarifé au titre du Tableau 5, n° 137 (Art A444-143) et n° 138 (Art A444-144). Cautionnement associé acte
          tarifé au titre du Tableau 5, n° 111 (Art A444-127).
        </p>

        {props?.isParent === true && props.departements !== "" ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Département :</div>

            <SelectDepartement
              items={props.departements}
              nameField={"name"}
              defaultValue={currUserDep}
              optionValue={"id"}
              handleChange={handleChange}
              setter={setDepartement}
            />
          </div>
        ) : (
          <></>
        )}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>La vente est-elle consentie "Acte en main" ?</div>
          <div>
            <ButtonYesno handleChange={handleChange} setter={setActeEnMain} fieldUndefined={false} defaultValue={0} />
          </div>
        </div>

        <div className="cardRow">
          {acteEnMain === 0 ? (
            <div style={styles.cardElemVerticalyCenter}>Quel est le montant de la vente ?</div>
          ) : (
            <div style={styles.cardElemVerticalyCenter}>Quel est le montant de la vente "acte en main" ?</div>
          )}

          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le montant"}
            setter={setMontantVente}
          />
        </div>

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Quel est le montant de la partie exigible du prix de vente :</div>

          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le montant"}
            setter={setMontantExigible}
          />
        </div>

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Quel est le taux de TVA qui concerne l'opération ?
            <ToolTipPerso title={"Le taux de TVA peut être soit réduit, soit intermédiaire, soit normal."} />
          </div>
          <SelectCommon
            items={tvaVefa}
            defaultValue={0.2}
            nameField={"name"}
            optionValue={"id"}
            handleChange={handleChange}
            setter={setTva}
          />
        </div>

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Y a-t-il des débours additionnels à prévoir ?
            <ToolTipPerso
                title={
                  "Les débours sur les ventes comprennent une somme de 120 euros représentant le coût moyen d'obtention d'un certificat d'urbanisme complet. Pour retirer ce coût, répondre 'non' à la question."
                }
            />
          </div>
          <div>
            <ButtonYesno handleChange={handleChange} setter={setDeboursAdditionnels} fieldUndefined={true} defaultValue={2} />
          </div>
        </div>

        {parseInt(deboursAdditionnels) === 1 ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Montant des débours additionnels :</div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le montant"}
              setter={setMontantDeboursAdditionnels}
            />
          </div>
        ) : (
          <></>
        )}
        <CautionSansGarantieHypo
          cautionSansGarantieHypo={cautionSansGarantieHypo}
          setCautionSansGarantieHypo={setCautionSansGarantieHypo}
          setSimu114={setSimu114}
          simulateur={props.simulateur}
          departementId={departement}
          handleChange={handleChange}
        />

        <div
          className="cardRow"
          style={parseInt(cautionSansGarantieHypo) === 1 ? { opacity: 0.5, pointerEvents: "none" } : {}}
        >
          <div style={styles.cardElemVerticalyCenter}>
            Y a-t-il un prêt hypothécaire ?
            <ToolTipPerso
              title={"Accessoires compris et évalués au bordereau à concurrence de 20% du capital emprunté."}
            />
          </div>
          <div>
            <ButtonYesno handleChange={handleChange} setter={setPretHypo} fieldUndefined={false} defaultValue={0} />
          </div>
        </div>

        {parseInt(cautionSansGarantieHypo) !== 1 && parseInt(pretHypo) === 1 ? (
          <>
            <Simulateur_A1_12VEFA
              // simulateur={props.simulateur}
              // isParent={false}
              // departements={departements}
              simulateur={props.simulateur}
              isParent={false}
              departementId={departement}
              dependances={setSimu85}
            />
          </>
        ) : (
          <></>
        )}
        
        <ConventionHonoraires
          handleChange={handleChange}
          conventionHonoraires={props.conventionHonoraires}
          setConventionHonoraires={props.setConventionHonoraires}
          nombreConventionHonoraires={props.nombreConventionHonoraires}
          setNombreConventionHonoraires={props.setNombreConventionHonoraires}
          objectConventionHonoraires={props.objectConventionHonoraires}
          setObjectConventionHonoraires={props.setObjectConventionHonoraires}
          montantConventionHonoraires={props.montantConventionHonoraires}
          setMontantConventionHonoraires={props.setMontantConventionHonoraires}
          nomSignataireConventionHonoraires={props.nomSignataireConventionHonoraires}
          setNomSignataireConventionHonoraires={props.setNomSignataireConventionHonoraires}
          adresseSignataireConventionHonoraires={props.adresseSignataireConventionHonoraires}
          setAdresseSignataireConventionHonoraires={props.setAdresseSignataireConventionHonoraires}
        />
      </div>
    </div>
  );
}

export default Simulateur_A2_5;
